import FeedbackManagement from '@/pages/Admin/FeedbackManagement/FeedbackManagement';
export default FeedbackManagement;
